import mutations from "./helpers/mutations";

(function () {
  const ELEMENTS = [];
  const BOXSELECTOR = "[data-component=video-box]";
  const SELECTOR = "[data-component=video-gallery]";

  function cachebustParameter() {
    return `&cachebust=${Math.floor(Math.random() * 1e8)}`;
  }

  function updateVideobox(box, iframe, srcBox) {
    const parent = box.closest(SELECTOR);
    const currentId = parent.getAttribute("aria-activedescendant").split("video_").pop();
    const itemId = srcBox.id.split("video_").pop();

    // update iframe
    iframe.setAttribute("hidden", "");
    iframe.dataset.src = srcBox.dataset.src;
    iframe.src = "";

    // update ids
    box.id = `video_${itemId}`;
    srcBox.id = `video_${currentId}`;

    // update filmstrip image and media source
    srcBox.dataset.src = srcBox.dataset.src.replace(itemId, currentId);
    const img = srcBox.querySelector("img");

    parent.setAttribute("aria-activedescendant", box.id);
    img.srcset = img.srcset.replace(itemId, currentId);
  }

  function play(e) {
    const { target } = e;
    const srcBox = target.closest(BOXSELECTOR);
    const videoGallery = target.closest(SELECTOR);
    const box = videoGallery.querySelector(BOXSELECTOR);
    const iframe = box.querySelector("iframe");

    if (!iframe) {
      return;
    }

    if (srcBox !== box) {
      updateVideobox(box, iframe, srcBox);
    }

    setTimeout(() => {
      iframe.src = `${iframe.dataset.src}&autoplay=1&rel=0${cachebustParameter()}`;
      iframe.removeAttribute("hidden");
    }, 50);
  }

  function process(videoGallery) {
    if (videoGallery.dataset.processed) {
      return;
    }

    const elements = videoGallery.querySelectorAll("picture, button");

    elements.forEach(element => {
      ELEMENTS.push(element);
      element.addEventListener("click", play);
    });

    videoGallery.dataset.processed = true;
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(process);
  }

  function dispose() {
    while (ELEMENTS.length) {
      const element = ELEMENTS.pop();

      if (element) {
        element.removeEventListener("click", play);
      }
    }
  }

  document.addEventListener("DOMContentLoaded", init, { once: true });
  window.addEventListener("beforeunload", dispose);

  mutations.add(SELECTOR, process);
})();



// WEBPACK FOOTER //
// ./shared/video-gallery.js